import customers from '../views/customers/index.vue'
import customers_create from '../views/customers/create.vue'
import customers_edit from '../views/customers/edit.vue'
import customers_detail from '../views/customers/detail.vue'
import customers_import from '../views/customers/import.vue'

const routes = [
  {
    path: "/customers",
    name: "customers",
    component: customers,
    meta: { authOnly: true },
  },
  {
    path: "/customers/create",
    name: "customers_create",
    component: customers_create,
    meta: { authOnly: true },
  },
  {
    path: "/customers/edit/:uuid",
    name: "customers_edit",
    component: customers_edit,
    meta: { authOnly: true },
  },
{
    path: "/customers/detail/:uuid",
    name: "customers_detail",
    component: customers_detail,
    meta: { authOnly: true },
  },
{
    path: "/customers/import",
    name: "customers_import",
    component: customers_import,
    meta: { authOnly: true },
  }]

export default routes
